// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"82bbc221","453":"6b759d06","463":"9a04b426","789":"d074f1ce"}[chunkId] + ".chunk.js";
};